import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/test/home-list-test.png'


const _hoisted_1 = { class: "blog-lists" }
const _hoisted_2 = { class: "lists" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"background-shadow\"></div><div class=\"lists-item-left\"><div class=\"water-wave\"></div><div class=\"water-wave\"></div><div class=\"water-wave\"></div><img src=\"" + _imports_0 + "\" alt=\"\"></div>", 2)
const _hoisted_5 = { class: "lists-item-center" }
const _hoisted_6 = {
  class: "title",
  style: {"color":"#333"}
}
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-24gf-tags4" }, null, -1)
const _hoisted_10 = { class: "lists-item-right" }
const _hoisted_11 = { class: "time" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-shijian" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "complete" }, "阅读全文>>", -1)


const __default__ = { name: '' };

import '@/assets/svg/home-svg/fonticon/iconfont.css';
import {reactive, ref, onBeforeMount, onMounted, computed} from 'vue';
import { ElPagination } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  toTalLists: {
    type: Array,
    default: [],
  }
},
  setup(__props, { expose }) {

const props = __props


let lists = ref()
const pageSize = ref(5)
const currentPage = ref(1)
const handleSizeChange = (val: any) => {
  pageSize.value = val
}
const handleCurrentChange = (val: any) => {
  currentPage.value = val
  lists.value = getList(props.toTalLists, currentPage.value, pageSize.value)
  
}

const getList = (data: any, num: any, size: any) => {
  let list, total, start: any, end, isFirst, isLast
  total = data.length
  isFirst = total < size
  isLast = Math.ceil(total / size) === num
  start = (num - 1) * size
  end = isFirst && isLast ? start + (total % size) : start + size
  list = data.slice(start, end)
  // list.forEach((item: any, index: any) => {
  //   item.seq = index + start
  // })
  return list
}
onMounted(() => {
  lists.value = getList(props.toTalLists, currentPage.value, pageSize.value)
});
expose({
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lists), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "lists-item",
          key: item.id
        }, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.text), 1),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.label, (i, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "label-item",
                  key: index
                }, _toDisplayString(i[index]), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(item.time), 1)
            ]),
            _hoisted_13
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_unref(ElPagination), {
      onSizeChange: handleSizeChange,
      onCurrentChange: handleCurrentChange,
      "current-page": currentPage.value,
      "page-sizes": [5, 10, 20],
      "page-size": pageSize.value,
      "pager-count": 5,
      layout: "total, sizes, prev, pager, next, jumper",
      total: props.toTalLists.length,
      background: ""
    }, null, 8, ["current-page", "page-size", "total"])
  ]))
}
}

})